// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* hide top question cluster nav for showing results in dialog for student progress. */
#progress-report-dialog .js-clusterResultsBlk .js-questionClusterNavContent,
#progress-report-dialog .js-clusterResultsBlk .js-resetInlineQuestions
{
    display:none!important;
}
#progress-report-dialog .cluster-sub-nav{
    border-top:1px solid #E9E9E9;
}`, "",{"version":3,"sources":["webpack://./src/main/ui/progress/student/studentProgress.css"],"names":[],"mappings":"AAAA,sFAAsF;AACtF;;;IAGI,sBAAsB;AAC1B;AACA;IACI,4BAA4B;AAChC","sourcesContent":["/* hide top question cluster nav for showing results in dialog for student progress. */\n#progress-report-dialog .js-clusterResultsBlk .js-questionClusterNavContent,\n#progress-report-dialog .js-clusterResultsBlk .js-resetInlineQuestions\n{\n    display:none!important;\n}\n#progress-report-dialog .cluster-sub-nav{\n    border-top:1px solid #E9E9E9;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
